'use client'

import { Sun } from '@phosphor-icons/react'
import { useTheme } from 'next-themes'
import * as React from 'react'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

export function ModeToggle({ className }: { className?: string } = {}) {
  const { setTheme, resolvedTheme } = useTheme()

  const handleThemeToggle = React.useCallback(
    (e?: React.MouseEvent) => {
      const newMode = resolvedTheme === 'dark' ? 'light' : 'dark'
      const root = document.documentElement

      if (!document.startViewTransition) {
        setTheme(newMode)
        return
      }

      // Set coordinates from the click event
      if (e) {
        root.style.setProperty('--x', `${e.clientX}px`)
        root.style.setProperty('--y', `${e.clientY}px`)
      }

      document.startViewTransition(() => {
        setTheme(newMode)
      })
    },
    [resolvedTheme, setTheme]
  )

  return (
    <Button
      variant="secondary"
      size="icon"
      className={cn('group/toggle size-8', className)}
      onClick={handleThemeToggle}
    >
      <Sun />
      <span className="sr-only">Toggle theme</span>
    </Button>
  )
}
